import { render } from "./LimitedCompanyWorkStationComponent.vue?vue&type=template&id=0da14125&scoped=true&ts=true"
import script from "./LimitedCompanyWorkStationComponent.vue?vue&type=script&lang=ts"
export * from "./LimitedCompanyWorkStationComponent.vue?vue&type=script&lang=ts"

import "./LimitedCompanyWorkStationComponent.vue?vue&type=style&index=0&id=0da14125&lang=scss&scoped=true"
import "./LimitedCompanyWorkStationComponent.vue?vue&type=style&index=1&id=0da14125&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0da14125"]])

export default __exports__